<template lang="pug">
yz-dialog(v-model="show" persistent max-width="540")
  yz-card
    yz-dialog-normal-header(title="Edit supplier details" @close="onCancel")
    .px-6.py-4
      .yz-medium-body-xs.text-neutral-500.mb-1 Sold by
      .yz-heading-9.text-neutral-700.mb-4 {{ supplierName }}
      yz-card.pa-4(outlined color="neutral-200")
        yz-radio-group(v-model="pendingPicIndex" direction="vertical" :spacing="12")
          div.d-flex.align-center(v-for="(contact, index) in contacts" :key="index")
            yz-radio(:value="index")
            v-row.ml-5.d-flex(no-gutters)
              v-col(cols="6")
                .yz-medium-body-xs.text-neutral-500 PIC name
                .yz-regular-body-sm.text-neutral-700 {{ contact.name || '-' }}
              v-col(cols="6")
                .yz-medium-body-xs.text-neutral-500 Phone number
                .yz-regular-body-sm.text-neutral-700 {{ contact.phone || '-' }}
    yz-dialog-normal-actions(@save="onSave" @cancel="onCancel")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    supplierName: {
      type: String,
      default: ''
    },
    contacts: {
      type: Array,
      default: () => []
    },
    currentPicIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pendingPicIndex: null
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) this.pendingPicIndex = this.currentPicIndex
    }
  },
  methods: {
    onSave() {
      this.$emit('save', this.pendingPicIndex)
      this.show = false
    },
    onCancel() {
      this.show = false
    }
  }
}
</script>
